import { KommerSnart } from '../../../components/ui/KommerSnart'

export function BrugerTab() {
  return (
    <KommerSnart
      description="Brugeradministration med roller og adgangsstyring. Inviter medarbejdere og tildel dem adgang til specifikke funktioner."
    />
  )
}
